import { IsBoolean, IsOptional } from "class-validator";
import { CreativeUnitDimensionsUnit } from './creative-unit/creative-unit.dto';

export class PrintBoxPropertiesDto {
	llx: number; // lower left x in points
	lly: number; // lower left y in points
	urx: number; // upper right x in points
	ury: number; // upper right y in points
	displayUnit?: CreativeUnitDimensionsUnit | string; // UI-only display unit for displaying values; does not affect the rest of the properties
	advancedMode?: boolean; // UI-only flag to indicate whether advanced mode is enabled; does not affect the rest of the properties
}

export class ColorMappingItemDto {
	/**
	 * Hex color code is the key, CMYK color code is the value.
	 * Example: { '#ff0000': '0,100,100,0' }
	 */
	[hexColor: string | number]: string;
}


export class PrintConfigDto {
	// TODO: Should more strictly type this...
	@IsOptional()
	@IsBoolean()
	addBleeds?: boolean;

	@IsOptional()
	@IsBoolean()
	addMirroredBleeds?: boolean;

	@IsOptional()
	@IsBoolean()
	addCropMarks?: boolean;

	@IsOptional()
	bleedBox?: PrintBoxPropertiesDto;

	@IsOptional()
	colorMapping?: ColorMappingItemDto;
}

export const defaultPrintConfig: PrintConfigDto = {
	bleedBox: {
		llx: 0,
		lly: 0,
		urx: 0,
		ury: 0
	},
	colorMapping: {}
};
